import { useCallback, MouseEventHandler } from 'react';
import { useStore } from '@ui/hooks/useStore';
import { lang } from '@lang/interfaces/lang';
import getLiElementId from '@utils/getLiElementId';

const useLangSelector = () => {
    const { lang } = useStore();

    const handleLangChange = useCallback((language: string) => {
        lang.setLanguage(language);
    }, []);
    const handleLangClick: MouseEventHandler<HTMLElement> = useCallback((e) => {
        const language = getLiElementId(e.target as HTMLElement);
        if (language) {
            handleLangChange(language);
        }
    }, []);
    const handlers = {
        handleLangChange,
        handleLangClick,
    };

    return {
        lang,
        handlers,
    };
};

export default useLangSelector;
